import { useEffect } from 'react';
import { useQuery } from 'react-query';
import { useAppDispatch, useAppSelector } from '@app/store/hooks';
import { getUserInfo } from '@shared/services/get-user-info.service';
import { setUserInfo } from '@features/auth/slices/auth-slice';

export function useUserInfo() {
  const dispatch = useAppDispatch();
  const { userToken, userInfo } = useAppSelector(state => state.auth);

  const { data: user, refetch } = useQuery(['user/info'], getUserInfo, {
    refetchOnWindowFocus: false,
    refetchInterval: 60000,
    enabled: !!userToken,
  });

  useEffect(() => {
    if (user) dispatch(setUserInfo(user));
  }, [user]);

  return {
    userInfo,
    refetch,
  };
}
